import { useDebateContext } from "contexts/DebateContext";
import { TYPO } from "styles/Typo";

function DiscussCommentButton({
  size = 28,
  from = "agenda",
}: {
  size?: number;
  from?: "agenda" | "floating";
}) {
  const { opinionList } = useDebateContext();

  return (
    <div
      className="flex items-center gap-1 cursor-pointer"
      onClick={() => {
        const opinionInput = document.getElementById("opinion-input");
        if (opinionInput) {
          opinionInput.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }}
      data-gtm-id={`report-${from}-comment-button`}
    >
      <CommentIcon size={size} />
      <p
        className={`${
          size === 28 ? TYPO.TYPO5_1_RG : TYPO.TYPO7_RG
        } text-gray30`}
      >
        {opinionList?.length || 0}
      </p>
    </div>
  );
}
const CommentIcon = ({ size }: { size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M7.7 21.2915L5.285 23.7065C4.9525 24.039 4.57187 24.1134 4.14312 23.9296C3.71437 23.7459 3.5 23.4178 3.5 22.9453V7.6415C3.5 7.064 3.70563 6.56963 4.11687 6.15838C4.52813 5.74713 5.0225 5.5415 5.6 5.5415H22.4C22.9775 5.5415 23.4719 5.74713 23.8831 6.15838C24.2944 6.56963 24.5 7.064 24.5 7.6415V19.1915C24.5 19.769 24.2944 20.2634 23.8831 20.6746C23.4719 21.0859 22.9775 21.2915 22.4 21.2915H7.7Z"
        fill="var(--gray30)"
      />
    </svg>
  );
};
export default DiscussCommentButton;
